const testimonialData = [
  {
    name: "Chuck Roast",
    association: "Telluride Company Inc",
    url: "http://www.google.com",
    title: "World Class!",
    content:
      "<p>Odit non soluta reiciendis hic aut. Iusto mollitia debitis maiores aut et beatae. Dolor provident nobis sed. Perspiciatis dignissimos dignissimos debitis perspiciatis delectus ad necessitatibus. Sed qui vel et. Quia omnis vel nostrum ad.</p><p>Nihil quisquam dolore aut voluptas minima hic ipsam et. Eum quidem minus ad sed alias. Quia fuga animi qui dignissimos saepe voluptatem iure. Quae quam modi cumque quibusdam sint quo molestiae.</p><p>Nemo non molestias voluptate rerum autem dolores minima. Sed quam aperiam odit sit vero. Soluta quasi a magni necessitatibus.</p>"
  },
  {
    name: "Bob Dole",
    content:
      "<p>Odit non soluta reiciendis hic aut. Iusto mollitia debitis maiores aut et beatae. Dolor provident nobis sed. Perspiciatis dignissimos dignissimos debitis perspiciatis delectus ad necessitatibus. Sed qui vel et. Quia omnis vel nostrum ad.</p><p>Nihil quisquam dolore aut voluptas minima hic ipsam et. Eum quidem minus ad sed alias. Quia fuga animi qui dignissimos saepe voluptatem iure. Quae quam modi cumque quibusdam sint quo molestiae.</p><p>Nemo non molestias voluptate rerum autem dolores minima. Sed quam aperiam odit sit vero. Soluta quasi a magni necessitatibus.</p>"
  }
];
export default testimonialData;



// WEBPACK FOOTER //
// ./src/data/testimonial-data.js